"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[993],{

/***/ 755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LL": function() { return /* binding */ CircularPos2dIcon; },
  "kp": function() { return /* binding */ S3Icon; },
  "os": function() { return /* binding */ StitchIcon; },
  "FE": function() { return /* binding */ TriangleIcon; },
  "OR": function() { return /* binding */ WeTransferIcon; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(74098);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_@types+react@17.0.87_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(34633);
;// CONCATENATED MODULE: ./utils/generalLib.js
function range(start, end) {
    var step = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return Array.from({
        length: Math.ceil((end - start) / step)
    }, function(_, i) {
        return start + i * step;
    });
}

;// CONCATENATED MODULE: ./components/Icons.js





var StitchIcon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    viewBox: "-100 -100 1227 1224",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M962.56 170.666667l37.546667-34.133334c30.72-30.72 30.72-81.92 0-116.053333-30.72-30.72-85.333333-30.72-116.053334 0L843.093333 68.266667c-105.813333-58.026667-211.626667-68.266667-310.613333-68.266667-150.186667 0-232.106667 75.093333-232.106667 211.626667 0 153.6 150.186667 266.24 157.013334 273.066666 3.413333 3.413333 6.826667 3.413333 6.826666 3.413334L3.413333 996.693333c-6.826667 6.826667-6.826667 17.066667 0 23.893334 3.413333 3.413333 10.24 3.413333 13.653334 3.413333 3.413333 0 6.826667 0 10.24-3.413333L546.133333 549.546667c17.066667 13.653333 40.96 27.306667 64.853334 40.96 85.333333 54.613333 204.8 129.706667 204.8 201.386666 0 95.573333-85.333333 197.973333-327.68 197.973334-10.24 0-17.066667 6.826667-17.066667 17.066666s6.826667 17.066667 17.066667 17.066667c266.24 0 361.813333-126.293333 361.813333-232.106667 0-88.746667-122.88-167.253333-221.866667-228.693333-20.48-13.653333-40.96-27.306667-58.026666-37.546667l365.226666-331.093333C972.8 238.933333 989.866667 283.306667 989.866667 317.44c0 95.573333-37.546667 146.773333-112.64 153.6-10.24 0-17.066667 10.24-13.653334 20.48 0 10.24 6.826667 13.653333 17.066667 13.653333h3.413333c92.16-10.24 143.36-78.506667 143.36-187.733333C1024 273.066667 1003.52 225.28 962.56 170.666667z m-30.72-78.506667c6.826667 6.826667 6.826667 17.066667 0 23.893333l-10.24 10.24c-3.413333-3.413333-6.826667-6.826667-10.24-13.653333-6.826667-6.826667-17.066667-6.826667-23.893333 0l20.48-20.48c6.826667-6.826667 17.066667-6.826667 23.893333 0zM477.866667 453.973333s-143.36-109.226667-143.36-245.76C334.506667 64.853333 443.733333 34.133333 532.48 34.133333c92.16 0 191.146667 6.826667 286.72 61.44l-334.506667 372.053334c0-6.826667-3.413333-10.24-6.826666-13.653334z m413.013333-296.96c-3.413333 3.413333-6.826667 3.413333-13.653333 3.413334s-10.24 0-13.653334-3.413334c-6.826667-6.826667-6.826667-17.066667 0-23.893333l23.893334-20.48c-6.826667 6.826667-6.826667 17.066667 0 23.893333 3.413333 3.413333 6.826667 6.826667 10.24 13.653334l-6.826667 6.826666z"
    })
}));
var S3Icon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 512.002 512.002",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M392.566,159.4c-0.649-79.601-31.851-134.481-80.25-141.944l-1.443-10.127c-0.324-2.246-1.52-4.261-3.339-5.619 c-1.81-1.358-4.09-1.947-6.327-1.622l-92.99,13.287c-4.671,0.666-7.916,4.995-7.25,9.666l1.605,11.229 c-0.709,0.179-1.417,0.307-2.075,0.692c-52.122,30.126-68.688,71.677-77.346,122.859c-34.293,13.773-55.008,33.157-55.008,55.316 c0,11.997,6.242,23.149,17.24,33.072c-0.12,0.922,42.712,207.763,42.712,207.763c0.06,0.273,0.128,0.555,0.213,0.828 c10.64,33.678,63.146,57.203,127.693,57.203c66.963,0,118.308-23.107,127.906-58.031c0,0,42.832-206.841,42.712-207.763 c10.998-9.922,17.24-21.074,17.24-33.072C443.86,191.797,424.595,173.054,392.566,159.4z M116.285,210.472 c-1.221,10.887-2.545,22.167-4.022,33.712c-17.326-9.606-27.043-20.545-27.043-31.048c0-11.989,12.723-24.541,34.933-35.044 C118.779,188.544,117.541,199.311,116.285,210.472z M205.134,52.218l0.658,4.637c0.324,2.246,1.52,4.261,3.339,5.619 c1.486,1.119,3.288,1.708,5.123,1.708c0.401,0,0.811-0.026,1.213-0.085l92.99-13.287c4.671-0.666,7.916-4.995,7.25-9.666 l-0.837-5.858c35.497,9.077,58.509,53.642,60.482,117.634c-32.021-10.477-73.214-16.634-119.35-16.634 c-43.797,0-83.051,5.593-114.312,15.123C149.895,109.609,165.129,76.836,205.134,52.218z M256.001,272.909 c-52.891,0-97.217-8.735-127.505-21.1c1.819-13.645,3.339-26.778,4.756-39.425c1.648-14.704,3.228-28.555,5.149-41.653 c29.724-10.341,70.208-17.368,117.6-17.368c100.641,0,170.781,31.5,170.781,59.773S356.642,272.909,256.001,272.909z"
    })
}));
var WeTransferIcon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 34 16",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M10.4136 11.9959C10.0873 11.4809 9.82024 11.2083 9.34554 11.2083C8.87085 11.2083 8.60383 11.4809 8.27748 11.9959L6.8534 14.2677C6.31937 15.1461 5.87434 15.752 4.83595 15.752C3.79755 15.752 3.32286 15.3279 2.8185 14.1465C2.19546 12.6926 1.54276 10.9357 0.949389 8.57293C0.296684 5.9371 0 4.30137 0 2.96855C0 1.63573 0.415357 0.848157 1.83944 0.575535C3.79755 0.212039 6.43804 0 9.34554 0C12.253 0 14.8935 0.212039 16.8516 0.575535C18.2757 0.848157 18.6911 1.63573 18.6911 2.96855C18.6911 4.30137 18.3944 5.9371 17.7417 8.57293C17.1483 10.9357 16.4956 12.6926 15.8726 14.1465C15.3682 15.3279 14.8935 15.752 13.8551 15.752C12.8167 15.752 12.3717 15.1461 11.8377 14.2677L10.4136 11.9959ZM32.9913 14.122C31.9826 15.2124 30.0838 16 27.5917 16C22.5777 16 19.6108 12.5165 19.6108 7.94252C19.6108 3.03532 23.0227 0.12735 27.4433 0.12735C31.3892 0.12735 34 2.21745 34 5.03455C34 7.70019 31.7749 9.42679 29.2531 9.42679C27.8883 9.42679 26.8796 9.15417 26.1972 8.60893C25.9302 8.39689 25.7819 8.42718 25.7819 8.66951C25.7819 9.66912 26.1379 10.5173 26.7906 11.1837C27.3246 11.7289 28.3334 12.0924 29.2828 12.0924C30.2618 12.0924 31.1222 11.8804 31.8936 11.4866C32.665 11.0928 33.3177 11.214 33.7034 11.8501C34.1484 12.5771 33.5254 13.5161 32.9913 14.122Z"
    })
}));
var CircularPos2dIcon = function(props) {
    var mapToCircle = function mapToCircle(p) {
        var x = p.x, y = p.y;
        // Constrain to circle
        var len2 = x * x + y * y;
        var len = Math.sqrt(len2);
        if (len > 1) {
            x = x / len;
            y = y / len;
            len = 1;
            len2 = 1;
        }
        // Non-linear mapping
        var z = Math.sqrt(1 - len2);
        var elevation = len2 > 1 ? 0 : Math.acos(Math.sqrt(len2));
        if (len > 0) {
            x = x / len * (1 - elevation / (Math.PI / 2));
            y = y / len * (1 - elevation / (Math.PI / 2));
        }
        return {
            x: x,
            y: y
        };
    };
    var Reticle = function Reticle(props) {
        var x = props.x, y = props.y, width = props.width, stroke = props.stroke;
        var ref = mapToCircle({
            x: x,
            y: y
        }), cx = ref.x, cy = ref.y;
        var px = (cx + 1) / 2 * size + retLen;
        var py = (-cy + 1) / 2 * size + retLen;
        var angles = range(0, 359, 45).map(function(d) {
            return d * Math.PI / 180;
        });
        var rc = retLen * 1.0;
        var r0 = retLen * 1.5;
        var r1 = retLen * 2.0;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: px,
                    cy: py,
                    r: rc,
                    stroke: stroke,
                    strokeWidth: width,
                    fill: "none"
                }),
                angles.map(function(a) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                        x1: px + r0 * Math.cos(a),
                        y1: py - r0 * Math.sin(a),
                        x2: px + r1 * Math.cos(a),
                        y2: py - r1 * Math.sin(a),
                        stroke: stroke,
                        strokeWidth: width
                    }, a);
                })
            ]
        });
    };
    var mode = props.mode, anchored = props.anchored, moving = props.moving, stationary = props.stationary;
    var size = 100; // Size of rasterisation
    var sw = 4; // Stroke width of thickest elements
    var retLen = 6; // Length of reticle arms
    var c = size / 2 + retLen;
    return (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 ".concat(size + retLen * 2, " ").concat(size + retLen * 2),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: retLen,
                y1: c,
                x2: size + retLen,
                y2: c,
                stroke: "grey",
                strokeWidth: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: c,
                y1: retLen,
                x2: c,
                y2: size + retLen,
                stroke: "grey",
                strokeWidth: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: c,
                cy: c,
                r: size / 2 - sw / 2,
                stroke: "black",
                strokeWidth: sw,
                fill: "none"
            }),
            mode === "moving" && anchored && stationary && stationary.map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reticle, {
                    x: p.x,
                    y: p.y,
                    width: sw / 2,
                    stroke: "grey"
                }, i);
            }),
            mode === "moving" && moving && moving.map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reticle, {
                    x: p.x,
                    y: p.y,
                    width: sw / 2,
                    stroke: "black"
                }, i);
            }),
            mode === "stationary" && stationary && stationary.map(function(p, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Reticle, {
                    x: p.x,
                    y: p.y,
                    width: sw / 2,
                    stroke: "black"
                }, i);
            })
        ]
    }));
};
var TriangleIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 5 : _size, _color = param.color, color = _color === void 0 ? "#003fff" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            width: 0,
            height: 0,
            borderLeft: "".concat(size, "px solid transparent"),
            borderRight: "".concat(size, "px solid transparent"),
            borderTop: "".concat(size, "px solid ").concat(color),
            display: "inline-block"
        }
    });
};


/***/ }),

/***/ 98583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49634);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45160);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21849);
/* harmony import */ var _material_ui_icons_BackspaceSharp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47167);
/* harmony import */ var _material_ui_icons_AddSharp__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84520);






var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        tag: {
            height: "20px",
            minWidth: "0px",
            padding: theme.spacing(0.5)
        },
        label: {
            fontSize: "0.85em",
            color: "#303031",
            whiteSpace: "nowrap"
        },
        count: {
            fontSize: "0.8em",
            color: "#999"
        },
        clickable: {
            cursor: "pointer"
        },
        user: {
            backgroundColor: "#ddeeff"
        },
        auto: {
            backgroundColor: "#ebeeee"
        },
        specialAdd: {
            backgroundColor: "#ddeeff"
        },
        iconButton: {
            height: "20px",
            width: "20px"
        },
        icon: {
            height: "14px",
            width: "14px"
        }
    };
});
function Tag(props) {
    var classes = useStyles();
    var label = props.label, count = props.count, tagType = props.tagType, showButtons = props.showButtons, onClick = props.onClick, onDelete = props.onDelete;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (tagType != "specialAdd" || showButtons) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "".concat(classes.tag, " ").concat(classes[tagType], " ").concat(onClick && classes.clickable),
            color: "primary",
            size: "small",
            onClick: function() {
                return onClick && tagType != "specialAdd" && onClick(label);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.label,
                    children: label
                }),
                count && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.count,
                    children: " [".concat(count, "]")
                }),
                showButtons && onDelete && tagType == "user" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    title: "Remove tag",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        className: classes.iconButton,
                        onClick: onDelete,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_BackspaceSharp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: classes.icon
                        })
                    })
                }),
                showButtons && tagType == "specialAdd" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    title: "Add tag",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "small",
                        className: classes.iconButton,
                        onClick: onClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_AddSharp__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: classes.icon
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 28132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TagList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49634);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45160);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21162);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26482);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21849);
/* harmony import */ var _material_ui_icons_LocalOffer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(18911);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98583);
/* harmony import */ var _TagSelection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(701);









var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return {
        container: {
            position: "relative",
            textAlign: "center",
            pointerEvents: "auto",
            zIndex: 2
        },
        containerHoverClear: {
            maxWidth: "calc(100% + 4px) !important",
            overflow: "hidden",
            "&:hover": {
                flexWrap: "wrap",
                zIndex: 3
            }
        },
        containerHoverBackground: {
            backgroundColor: "#fafafa",
            maxWidth: "calc(100% + 4px) !important",
            overflow: "hidden",
            "&:hover": {
                flexWrap: "wrap",
                zIndex: 3
            }
        },
        containerAlwaysExpanded: {
            flexWrap: "wrap"
        },
        overlay: {
            position: "absolute",
            right: "0",
            bottom: "0",
            height: "28px",
            paddingRight: "0px !important",
            paddingLeft: "60px !important",
            display: "flex",
            background: "linear-gradient(90deg, " + "rgba(250,250,250,0) 0%, " + "rgba(250,250,250,1) 100%)"
        },
        popoverRoot: {
            minWidth: "172px",
            padding: theme.spacing(0.5)
        },
        textField: {}
    };
});
function TagList(props) {
    var materialId = props.materialId, tags = props.tags, indeterminate = props.indeterminate, onChange = props.onChange, tagChoices = props.tagChoices, alwaysExpanded = props.alwaysExpanded, onBlur = props.onBlur, onFocus = props.onFocus, onHover = props.onHover, iconOnly = props.iconOnly, iconClass = props.iconClass, iconTooltip = props.iconTooltip, hideOverlay = props.hideOverlay;
    var classes = useStyles();
    classes.containerHover = hideOverlay ? classes.containerHoverClear : classes.containerHoverBackground;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), anchor = ref[0], setAnchor = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(alwaysExpanded === true), isHovered = ref1[0], setIsHovered = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), selected = ref2[0], setSelected = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), selectedSecondary = ref3[0], setSelectedSecondary = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), textVal = ref4[0], setTextVal = ref4[1];
    var tagSelectionOpen = Boolean(anchor);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        function onTags() {
            return _onTags.apply(this, arguments);
        }
        function _onTags() {
            _onTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                var selectedTags, indeterminateTags;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    selectedTags = tags.filter(function(t) {
                        return t.tagType === "user";
                    }).map(function(t) {
                        return t.label;
                    });
                    indeterminateTags = (indeterminate !== null && indeterminate !== void 0 ? indeterminate : []).filter(function(t) {
                        return t.tagType === "user" && !selectedTags.includes(t.label);
                    }).map(function(t) {
                        return t.label;
                    });
                    setSelected(selectedTags);
                    setSelectedSecondary(indeterminateTags);
                    return [
                        2
                    ];
                });
            });
            return _onTags.apply(this, arguments);
        }
        onTags();
    }, [
        tags,
        indeterminate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (onHover) {
            onHover(!!tagSelectionOpen || isHovered, materialId);
        }
    }, [
        materialId,
        isHovered,
        onHover,
        tagSelectionOpen
    ]);
    function onTagSelection(fields) {
        return _onTagSelection.apply(this, arguments);
    }
    function _onTagSelection() {
        _onTagSelection = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(fields) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                setSelected(fields.tags);
                setSelectedSecondary(fields.tagsIndeterminate);
                if (onChange) {
                    onChange(materialId, {
                        selected: fields.tags,
                        secondary: fields.tagsIndeterminate
                    });
                }
                return [
                    2
                ];
            });
        });
        return _onTagSelection.apply(this, arguments);
    }
    function onAdd(event) {
        return _onAdd.apply(this, arguments);
    }
    function _onAdd() {
        _onAdd = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(event) {
            var anchorEl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                anchorEl = event.currentTarget.parentElement.parentElement.parentElement;
                setAnchor(anchorEl);
                return [
                    2
                ];
            });
        });
        return _onAdd.apply(this, arguments);
    }
    function onDelete(deletedTag) {
        return _onDelete.apply(this, arguments);
    }
    function _onDelete() {
        _onDelete = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(deletedTag) {
            var newSel, newSec;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                newSel = selected.filter(function(t) {
                    return t !== deletedTag.label;
                });
                setSelected(newSel);
                newSec = (selectedSecondary !== null && selectedSecondary !== void 0 ? selectedSecondary : []).filter(function(t) {
                    return t !== deletedTag.label;
                });
                setSelectedSecondary(newSec);
                if (onChange) {
                    onChange(materialId, {
                        selected: newSel,
                        secondary: newSec
                    });
                }
                return [
                    2
                ];
            });
        });
        return _onDelete.apply(this, arguments);
    }
    function onTextEnter(event) {
        return _onTextEnter.apply(this, arguments);
    }
    function _onTextEnter() {
        _onTextEnter = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(event) {
            var val, selectedTags;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                if (event.key == "Enter") {
                    val = event.target.value;
                    if (val.length > 0 && !tags.includes(val)) {
                        selectedTags = [];
                        tags.forEach(function(tag) {
                            if (tag.tagType == "user") {
                                selectedTags.push(tag.label);
                            }
                        });
                        selectedTags.push(val);
                        if (onChange) {
                            onChange(materialId, {
                                selected: selectedTags,
                                secondary: selectedSecondary
                            });
                        }
                    }
                    setTextVal("");
                }
                return [
                    2
                ];
            });
        });
        return _onTextEnter.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            iconOnly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                title: iconTooltip !== null && iconTooltip !== void 0 ? iconTooltip : "Set tags",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    className: iconClass,
                    onClick: function(event) {
                        setAnchor(event.currentTarget);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_LocalOffer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                container: true,
                spacing: 1,
                wrap: "nowrap",
                className: "".concat(classes.container, " ").concat(alwaysExpanded ? classes.containerAlwaysExpanded : classes.containerHover),
                onMouseEnter: function() {
                    setIsHovered(true);
                },
                onMouseLeave: function() {
                    setIsHovered(alwaysExpanded === true);
                },
                children: [
                    tags && tags.map(function(tag, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                label: tag.label,
                                tagType: tag.tagType,
                                onDelete: function() {
                                    return onDelete(tag);
                                },
                                showButtons: isHovered
                            })
                        }, i);
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            tagType: "specialAdd",
                            onClick: onAdd,
                            showButtons: isHovered || tags.length == 0
                        })
                    }),
                    !hideOverlay && !isHovered && tags.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        item: true,
                        className: classes.overlay
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                id: "add-tags-popover",
                className: classes.popover,
                open: tagSelectionOpen,
                anchorEl: anchor,
                onClose: function() {
                    setAnchor(null);
                },
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classes.popoverRoot,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TagSelection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            tags: tagChoices,
                            selected: selected,
                            indeterminate: selectedSecondary,
                            setSelected: onTagSelection
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            className: classes.textField,
                            size: "small",
                            variant: "filled",
                            label: "Enter new tag name",
                            value: textVal,
                            onChange: function(e) {
                                return setTextVal(e.target.value);
                            },
                            onKeyDown: onTextEnter,
                            autoFocus: true,
                            onBlur: onBlur,
                            onFocus: onFocus
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TagSelection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92750);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64741);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45160);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21849);
/* harmony import */ var _material_ui_icons_IndeterminateCheckBoxSharp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8363);
/* harmony import */ var _Tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98583);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return {
        tagRow: {
            marginTop: theme.spacing(0.3),
            marginBottom: theme.spacing(0.3)
        },
        tagCheckbox: {
            width: "25px",
            height: "25px",
            cursor: "pointer"
        }
    };
});
function TagSelection(props) {
    //
    // tags           List of tags which can be selected, as a list of tag objects
    // selected       List of tags which are currently selected, as a list of strings
    // indeterminate  If present, list of tags which are currently indeterminate.
    // setSelected    Called when the selection is changed via this control.  A single
    //                argument is passed, which is an object containing two members: tags,
    //                and tagsIndeterminate, each being a list of names of tags selected and
    //                indeterminate.
    //
    var tags = props.tags, selected = props.selected, indeterminate = props.indeterminate, setSelected = props.setSelected;
    var classes = useStyles();
    function onClick(event) {
        return _onClick.apply(this, arguments);
    }
    function _onClick() {
        _onClick = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(event) {
            var tagName, arraySel, indexSel, arrayInd, indexInd;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                tagName = "";
                if (typeof event === "string") {
                    tagName = event;
                } else {
                    tagName = event.target.name;
                }
                arraySel = selected.slice();
                indexSel = arraySel.indexOf(tagName);
                arrayInd = [];
                indexInd = undefined;
                if (indeterminate) {
                    arrayInd = indeterminate.slice();
                    indexInd = arrayInd.indexOf(tagName);
                }
                if (indexSel > -1) {
                    // Selected: Remove from selected
                    arraySel.splice(indexSel, 1);
                } else if (indexInd > -1) {
                    // Indeterminate: Remove from indeterminate, add to selected
                    arrayInd.splice(indexInd, 1);
                    arraySel.push(tagName);
                } else {
                    // Neither: Add to selected
                    arraySel.push(tagName);
                }
                setSelected({
                    tags: arraySel,
                    tagsIndeterminate: arrayInd
                });
                return [
                    2
                ];
            });
        });
        return _onClick.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: tags.map(function(tag, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                container: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        className: classes.tagRow,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            label: tag.label,
                            count: tag.count,
                            tagType: tag.tagType,
                            onClick: onClick
                        })
                    }),
                    selected.includes(tag.label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: classes.tagCheckbox,
                            checked: selected.includes(tag.label),
                            name: tag.label,
                            onChange: onClick
                        })
                    }),
                    indeterminate && indeterminate.includes(tag.label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: classes.tagCheckbox,
                            onClick: function() {
                                return onClick(tag.label);
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_IndeterminateCheckBoxSharp__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                color: "secondary"
                            })
                        })
                    })
                ]
            }, i);
        })
    });
}


/***/ }),

/***/ 10114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R9": function() { return /* binding */ useStableCallback; },
/* harmony export */   "Wf": function() { return /* binding */ usePolling; }
/* harmony export */ });
/* unused harmony export useFormFields */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9970);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15767);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);







function useFormFields(initialState) {
    var ref = useState(initialState), fields = ref[0], setValues = ref[1];
    return [
        fields,
        function(event) {
            setValues(_object_spread_props(_object_spread({}, fields), _define_property({}, event.target.id, event.target.value)));
        }
    ];
}
function usePolling(pollFunc) {
    // Create a hook for polling a function at regular intervals.
    // Start polling by calling setPollTime with a positive number of seconds.
    // Stop polling by calling setPollTime with 0 seconds.
    // Polling stops automatically if the polled function returns true.
    //
    // Returns an array of three members:
    //   pollTime          - Time in seconds to poll for.
    //   setPollTime       - Function to set pollTime to a new value.  0 disables polling.
    //   pollsCompleted    - Number of polls completed since polling started.  The counter
    //                       resets if setPollTime is called with a new interval.
    //   setPollsCompleted - Function to set pollsCompleted.
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), pollTime = ref[0], setPollTime = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), userPollTime = ref1[0], setUserPollTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), pollsCompleted = ref2[0], setPollsCompleted = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        function doPolling() {
            return _doPolling.apply(this, arguments);
        }
        function _doPolling() {
            _doPolling = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                pollFunc()
                            ];
                        case 1:
                            // Call poll function and stop polling if it returns true
                            if (_state.sent() === true) {
                                setPollTime(0);
                                setUserPollTime(0);
                            }
                            // Increment polls completed
                            setPollsCompleted(pollsCompleted + 1);
                            return [
                                2
                            ];
                    }
                });
            });
            return _doPolling.apply(this, arguments);
        }
        var pollWithTime = pollTime;
        if (userPollTime != pollTime) {
            // User updated polling time.  Reset polls completed
            setPollTime(userPollTime);
            setPollsCompleted(0);
            pollWithTime = userPollTime;
        }
        if (pollWithTime > 0) {
            // Call polling function once immediately
            doPolling();
            // Keep polling with the given interval
            var intervalId = setInterval(doPolling, pollWithTime * 1000);
            // Stop polling when component is unmounted
            return function() {
                return clearInterval(intervalId);
            };
        }
    }, [
        userPollTime
    ]);
    return [
        pollTime,
        setUserPollTime,
        pollsCompleted,
        setPollsCompleted
    ];
}
// useStableCallback() adapted from: https://gist.github.com/rolandcoops/4364be2eff3586b0f8f3d0c10dc3be61
var throwReferenceError = function() {
    throw new ReferenceError("Callback was called directly while rendering, pass it as a callback prop instead.");
};
/**
 * Custom hook that wraps an unstable callback inside a stable wrapper callback.
 * Useful to e.g. keep an event handler prop stable when passing it down.
 *
 * @param {Function} callback - unstable callback to be wrapped
 * @param {Array} deps - list of values whose change will update the unstable callback reference (see React.useCallback)
 * @returns {Function} stable wrapped callback
 *
 * @example
 * // `handleClick` reference will not change even if deps change:
 * const handleClick = useStableCallback((event) => {
 *   console.log(someDep, event.target)
 * }, [someDep])
 */ function useStableCallback(callback, deps) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(throwReferenceError);
    // update stored callback ref if callback or deps change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        callback
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(deps)));
    // return stable wrapped callback
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _ref;
        return (_ref = ref).current.apply(_ref, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(args));
    }, [
        ref
    ]);
}


/***/ })

}]);